import { statBlock as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  title: 'Stat Block',
  select: ['No Of Countries Engel VolkersIsIn', 'No Of Advisors Americas'],
};

export default fakeProps(schema, TestData);
